import { createSlice } from '@reduxjs/toolkit';

export const canvasResolutionSlice = createSlice({
	name: 'canvasResolutionSlice',
	initialState: {
		value: 1920,
	},
	reducers: {
		toggleMobile: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { toggleMobile } = canvasResolutionSlice.actions;
export const selectedToggleValue = (state) => state.canvasResolution.value;
export default canvasResolutionSlice.reducer;
